import React from 'react';
import { Card } from '../../components/Card/Card';
import './Marketplace.css';

export const MarketplaceModule: React.FC = () => {
  return (
    <div className="marketplace-module">
      <div className="marketplace-header">
        <div className="marketplace-header__content">
          <h1>App Marketplace</h1>
          <p>Discover and deploy powerful applications for your infrastructure</p>
        </div>
      </div>

      <div className="marketplace-grid">
        <Card variant="bordered" className="marketplace-empty">
          <h2>🚧 Under Construction</h2>
          <p>The App Marketplace is currently being built. Check back soon!</p>
        </Card>
      </div>
    </div>
  );
};
